module.exports = __webpack_public_path__ + "img/format_paint.b4fdf198.svg";